export default __webpack_public_path__ + "static/media/circle-cross.5a7d7f8f.svg";